import styled from 'styled-components';
import variables, { mq, screenSize, fs } from '../../utils/variables';

export const Section = styled.div`
  position: relative;
  background-color: ${ props => props.dark ? variables.colors.backgroundDark : ((props.light) ? variables.colors.backgroundExtraLight : 'transparent')};

  > * {
    position: relative;
    z-index: 2;
  }

  &:first-child {
    ${screenSize('padding-top', 190)}
  }

  .cards-container {
    display: flex;
    flex-wrap: wrap;

    ${mq('xl')} {
      padding: 0 0 60px;
    }

    ${mq('xl', true)} {
      padding: 0 85px 95px;
    }
  }

  > .button-wrapper {
    display: flex;
    justify-content: center;
    padding: 0 20px 100px;
  }

  .button-wrapper-note {
    display: inline-block;

    p {
      text-align: center;

      &.button-note {
        display: flex;
        align-items: center;
        justify-content: center;
        
        ${screenSize('margin-top', 15)}
        ${fs(14)}
        color: ${variables.colors.grey};

        svg {
          margin-right: 10px;
        }
      }
    }
  }


  .tabs-cols {
    display: flex;
    justify-content: space-between;

    ${mq('s')} {
      flex-direction: column;
    }
  }

  .tabs-col {
    max-width: 25vw;

    ${mq('l')} {
      margin: 0 20px;
    }

    ${mq('m')} {
      max-width: 320px;
    }
  }

  .features-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0 auto;
    padding: 0 calc(4vw + 70px) 30px;

    ${mq('l')} {
      padding: 50px 35px 30px;
    }

    ${mq('s')} {
      padding: 35px 20px 30px;
    }
  }
  .features-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    margin-left: -30px;
    margin-right: -30px;
  }

  .feature-block {
    width: calc(33% - 60px);
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 50px;

    ${mq('l')} {
      width: calc(50% - 60px);
    }

    ${mq('s')} {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }

    h2 {
      margin-bottom: 25px;
      font-family: 'Bossa', sans-serif;
      font-weight: 500;
      line-height: 1.5;
      color: ${variables.colors.backgroundDark};
      margin-bottom: 40px;

      ${fs(52)}
    }

    .tag-soon {
      display: inline-block;
      padding: 5px 11px;
      margin-left: 10px;
      border-radius: 4px;
      white-space: nowrap;
      font-family: 'Bossa', sans-serif;
      font-weight: 500;
      line-height: 1.1;
      color: ${variables.colors.white};
      background: ${variables.colors.blue};
      ${fs(16)}
    }

    h3 {
      margin-bottom: 25px;
      font-family: 'Bossa', sans-serif;
      font-weight: 500;
      line-height: 1.5;
      color: ${variables.colors.blue};

      ${fs(20)}
    }

    p {
      font-family: 'Montserrat', sans-serif;
      font-weight: 500;
      
      line-height: 1.5;
      color: ${variables.colors.backgroundDark};

      ${fs(15)}
    }
  }
`;